var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-brands:x-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0719 3.5H29.4844L19.8469 14.5125L31.1844 29.5H22.3094L15.3531 20.4125L7.40313 29.5H2.98438L13.2906 17.7188L2.42188 3.5H11.5219L17.8031 11.8062L25.0719 3.5ZM23.5219 26.8625H25.9656L10.1906 6H7.56563L23.5219 26.8625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX);
export default __webpack_public_path__ + "static/media/Ic_X.ea6b58202f7a42a1f3675b44d8b6af52.svg";
export { ForwardRef as ReactComponent };